import { AppRoutes } from './routes/AppRoutes';
import { HottrChassisNav } from '@/components/layout/HottrChassisNav';
import { usePresenceHeartbeat } from '@/modules/app/hooks/usePresenceHeartbeat';
import { useHottieVoiceGraph } from '@/modules/hottie/useHottieVoiceGraph';
import { RequirePin } from '@/auth/RequirePin';

export default function App() {
  usePresenceHeartbeat();
  useHottieVoiceGraph();

  return (
    <RequirePin>
      {/*
        Flex row so the mounted chassis has a slot beside the page. OrbFan
        is position:fixed inside .hottr-dock, so it takes no flex slot itself.
        Hottie is the in-kit sheet on Orb hold — no second dock, and no
        desktop rail: one Orb at every width.
      */}
      <div data-hand="right" className="flex min-h-dvh">
        <HottrChassisNav />
        <div className="min-w-0 flex-1">
          <AppRoutes />
        </div>
      </div>
    </RequirePin>
  );
}
